import { FeedbackFirestorePersistenceContext } from "~applications";
import { createStaticContextProvider, lazyValue } from "~utils";

export const FeedbackPersistenceProvider = createStaticContextProvider(
  FeedbackFirestorePersistenceContext,
  lazyValue(() =>
    import("./feedback-persistence").then(
      (module) => module.feedbackPersistence,
    ),
  ),
);
